export default __webpack_public_path__ + "static/28-8227da73264701e157ef17e713a0b1c2.png";